// T22.456: the toolbar commands below have no per-editor state (they only use
// Froala's `this`), so they are registered ONCE at module load instead of in
// FroalaTextEditor's useEffect. Measured on web-stg main.3ee61e07.js: when the
// Text block pane is the first Froala editor a page mounts (deep link
// /builder/<id>?segment=<id>&pane=2 -> Add Text Here), react-froala-wysiwyg
// builds the toolbar in its componentDidMount, which runs BEFORE the parent's
// useEffect. Froala's own colors plugin also registers "customBackgroundColor"
// (its hex-input "OK" button, no icon), so that button rendered as the raw text
// "customBackgroundColor" and textColorCustom/simpleUL/bulletStyles were
// missing from the toolbar. Registering before any editor exists fixes both.
export function registerStaticToolbarCommands(core) {
  if (!core) return;
  core.DefineIcon("customFontSize", { SVG_KEY: "fontSize" });
  core.RegisterCommand("customFontSize", {
    title: "Custom Font Size",
    icon: "customFontSize",
    undo: true,
    focus: true,
    callback: function () {
      const fontSize = prompt("Enter font size (in px):", "16");
      if (fontSize && !isNaN(fontSize)) {
        this.format.applyStyle("font-size", `${fontSize}px`);
      }
    },
  });

  // Register simple button for applying default bullets
  core.DefineIcon("simpleUL", { SVG_KEY: "unorderedList" });
  core.RegisterCommand("simpleUL", {
    title: "Bullets",
    icon: "simpleUL",
    undo: true,
    focus: true,
    refreshAfterCallback: true,
    callback: function () {
      // Apply default bullets (disc)
      let ulElement = this.selection.element();
      let isAlreadyList = false;

      // Find closest UL element from current selection
      while (ulElement && ulElement.tagName !== "UL") {
        if (ulElement.tagName === "LI") {
          isAlreadyList = true;
        }
        ulElement = ulElement.parentNode;
      }

      if (isAlreadyList) {
        // If already a list, remove it (toggle behavior)
        this.commands.exec("formatUL");
      } else {
        // If not a list, create one with default bullet style
        this.commands.exec("formatUL");

        // Find the newly created UL and apply disc style
        ulElement = this.selection.element();
        while (ulElement && ulElement.tagName !== "UL") {
          ulElement = ulElement.parentNode;
        }

        if (ulElement && ulElement.tagName === "UL") {
          ulElement.style.listStyleType = "disc";
        }
      }

      // Force content refresh
      this.events.trigger("contentChanged");
    },
  });

  // Register dropdown for bullet styles
  core.DefineIcon("bulletStyles", { SVG_KEY: "moreText" });
  core.RegisterCommand("bulletStyles", {
    title: "Bullet Styles",
    type: "dropdown",
    focus: false,
    undo: true,
    refreshAfterCallback: true,
    options: {
      bullet: "Bullet",
      circle: "Circle",
      square: "Square",
    },
    callback: function (cmd, val) {
      // Only process if a specific option was selected
      if (val) {
        let element = this.selection.element();
        let isAlreadyUL = false;
        let isAlreadyOL = false;
        let listElement = null;

        // Check if we're already in a list (UL or OL)
        while (
          element &&
          element.tagName !== "UL" &&
          element.tagName !== "OL"
        ) {
          if (element.tagName === "LI") {
            // Found a list item, now find its parent list
            let parent = element.parentNode;
            if (parent && parent.tagName === "UL") {
              isAlreadyUL = true;
              listElement = parent;
            } else if (parent && parent.tagName === "OL") {
              isAlreadyOL = true;
              listElement = parent;
            }
            break;
          }
          element = element.parentNode;
        }

        // If we found a UL or OL directly
        if (
          element &&
          (element.tagName === "UL" || element.tagName === "OL")
        ) {
          listElement = element;
          isAlreadyUL = element.tagName === "UL";
          isAlreadyOL = element.tagName === "OL";
        }

        // If we're in an ordered list, remove it first
        if (isAlreadyOL) {
          this.commands.exec("formatOL");
        }

        // If we're not in an unordered list, create one
        if (!isAlreadyUL) {
          this.commands.exec("formatUL");
        }

        // Apply selected style to the UL
        element = this.selection.element();
        while (element && element.tagName !== "UL") {
          element = element.parentNode;
        }

        if (element && element.tagName === "UL") {
          switch (val) {
            case "bullet":
              element.style.listStyleType = "disc";
              break;
            case "circle":
              element.style.listStyleType = "circle";
              break;
            case "square":
              element.style.listStyleType = "square";
              break;
          }
        }

        // Force content refresh
        this.events.trigger("contentChanged");
      }
    },
  });

  core.DefineIcon("textColorCustom", { SVG_KEY: "textColor" });
  core.RegisterCommand("textColorCustom", {
    title: "Overwrite colors for specific words or text",
    icon: "textColorCustom",
    undo: true,
    focus: true,
    callback: function () {
      this.commands.exec("textColor");
    },
    refreshAfterCallback: true,
  });

  core.DefineIcon("customBackgroundColor", {
    SVG_KEY: "backgroundColor",
  });
  core.RegisterCommand("customBackgroundColor", {
    title: "Highlight",
    icon: "customBackgroundColor",
    undo: true,
    focus: true,
    callback: function () {
      this.commands.exec("backgroundColor");
    },
    refreshAfterCallback: true,
  });

  // Register empty toolbar button that does nothing
  core.DefineIcon("emptyToolbar", { SVG_KEY: null });
  core.RegisterCommand("emptyToolbar", {
    title: "",
    icon: "emptyToolbar",
    undo: false,
    focus: false,
    callback: function () {},
  });
}
